import { render } from "./aio-login-get-pro.vue?vue&type=template&id=26835bfa&scoped=true"
import script from "./aio-login-get-pro.vue?vue&type=script&lang=js"
export * from "./aio-login-get-pro.vue?vue&type=script&lang=js"

import "./aio-login-get-pro.vue?vue&type=style&index=0&id=26835bfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26835bfa"]])

export default __exports__